import { render, staticRenderFns } from "./wh7footer.vue?vue&type=template&id=6fe1cc5d&"
import script from "./wh7footer.vue?vue&type=script&lang=js&"
export * from "./wh7footer.vue?vue&type=script&lang=js&"
import style0 from "./wh7footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports